var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSendSmall = function SvgSendSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.848 2.14a.5.5 0 0 1 .134.492l-3 11a.5.5 0 0 1-.769.278L8.616 12.09l-1.762 1.763A.5.5 0 0 1 6 13.5v-3.24L1.213 6.91a.5.5 0 0 1 .14-.888l13-4a.5.5 0 0 1 .495.119ZM7 10.96l.784.549-.784.784V10.96Zm.032-1.198 4.173 2.92 2.354-8.632-6.527 5.712Zm-.844-.59L2.625 6.676l9.892-3.044-6.33 5.538Z",
    clipRule: "evenodd"
  })));
};
export default SvgSendSmall;